import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmpresaRoutingModule } from './empresa-routing.module';
import { MeuPlanoComponent } from './pages/meu-plano/meu-plano.component';
import { FinanceiroComponent } from './pages/financeiro/financeiro.component';
import { FinanceiroDashboardComponent } from './pages/financeiro/componentes/financeiro-dashboard.component';
import { FinanceiroContasPagarComponent } from './pages/financeiro/componentes/financeiro-contas-pagar.component';
import { FinanceiroContasReceberComponent } from './pages/financeiro/componentes/financeiro-contas-receber.component';
import { FinanceiroOrcamentoComponent } from './pages/financeiro/componentes/financeiro-orcamento.component';
import { FinanceiroModalContaComponent } from './pages/financeiro/componentes/financeiro-modal-conta.component';
import { FinanceiroModalPagamentoComponent } from './pages/financeiro/componentes/financeiro-modal-pagamento.component';
import { FinanceiroModalRecebimentoComponent } from './pages/financeiro/componentes/financeiro-modal-recebimento.component';
import { FinanceiroModalDeletarComponent } from './pages/financeiro/componentes/financeiro-modal-deletar.component';
import { FinanceiroModalOrcamentoComponent } from './pages/financeiro/componentes/financeiro-modal-orcamento.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxMaskDirective} from "ngx-mask";
import {CadastrarComponent} from "./pages/cadastrar/cadastrar.component";
import {BaseChartDirective, provideCharts, withDefaultRegisterables} from "ng2-charts";
import {NgSelectModule} from "@ng-select/ng-select";


@NgModule({
  declarations: [
    MeuPlanoComponent,
    FinanceiroComponent,
    FinanceiroDashboardComponent,
    FinanceiroContasPagarComponent,
    FinanceiroContasReceberComponent,
    FinanceiroOrcamentoComponent,
    FinanceiroModalContaComponent,
    FinanceiroModalPagamentoComponent,
    FinanceiroModalRecebimentoComponent,
    FinanceiroModalDeletarComponent,
    FinanceiroModalOrcamentoComponent,
    CadastrarComponent
  ],
    exports: [
        MeuPlanoComponent,
        FinanceiroDashboardComponent
    ],
    imports: [
        CommonModule,
        EmpresaRoutingModule,
        ComponentesModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        BaseChartDirective,
        NgSelectModule
    ],
    providers: [
      provideCharts(withDefaultRegisterables())
    ]
})
export class EmpresaModule { }
